const ORDER_STATUS_MAP = {
  WAIT_FOR_FEEDBACK: 0,
  QUOTED_FAILED: 1,
  CONFIRMED_FOR_UNDERWRITING: 2,
  CONFIRMING: 3,
  UNDERWRITING_FAILED: 4,
  WAIT_TO_PAY: 5,
  WAIT_PAY_CONFIRM: 6,
  SUCCESS: 7,
  CLOSED: 8,
}

const orderStatusList = {
  0: '待反馈报价',
  1: '报价失败',
  2: '待确认核保',
  3: '确认中',
  4: '核保失败',
  5: '待支付',
  6: '待确认',
  7: '已完成',
  8: '已关闭',
}

const orderDescList = {
  0: '保司正在报价中，请耐心等待',
  1: '请修改保险方案后重新提交报价，如有疑问可联系出单员',
  2: '请选择以下方案进行核保，如有疑问可联系出单员',
  3: '保司正在确认中，请耐心等待，如有疑问请联系出单员',
  4: '保险核保失败，请重新选择保险方案，如有问题可联系出单员了解详情',
  5: '保险公司已通过你的订单，请点击立即支付通过二维码进行线上支付',
  6: '保司正在确认中，请耐心等待，如有疑问请联系出单员',
  7: '你的订单已完成投保',
  8: '已关闭订单，如有疑问请联系出单员',
}

const UNDERWRITE_STATE = {
  SUCCESS: 5,
  CONFIRM: 3,
  FAIL: 4,
}

export { ORDER_STATUS_MAP, UNDERWRITE_STATE, orderStatusList, orderDescList }
